import { colors, IMForm, IMFormFooter, IMSubmitButton } from '@insurancemenu/imenu-components-lib';
import { styled } from 'styled-components';
import { GeneralTitleStyled } from '../../../globalStyles';

export const IMFormStyled = styled(IMForm)`
  padding: 0;
  margin: 0 auto;
  max-width: 85rem;
`;

export const TitleStyled = styled(GeneralTitleStyled)`
  margin-bottom: 1rem;
`;

export const GuidelinesStyled = styled.p`
  text-align: center;
  font-size: 1.4rem;
  line-height: 2rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: ${colors.blue[200]};
  margin-bottom: 4rem;
`;

export const InvitedEeGuidelineStyled = styled(GuidelinesStyled)`
  background-color: ${colors.green[100]};
`;

export const IMFormFooterStyled = styled(IMFormFooter)`
  padding-bottom: 1rem;
`;

export const IMSubmitButtonStyled = styled(IMSubmitButton)`
  width: 100%;
`;
